import { createI18n } from 'vue-i18n'
import useConfigStore from '@/store/config.js'
import { getCurrentLocale } from '@/utils/localeRoute.js'
import { LANGEN, LANGCN, LANGTW, LANGJA, LANGKO } from '@/utils/constant.js'

export const createLanguage = async () => {
  const langMessagesMap = {
    'zh': () => import('@/language/zh/index.js'),
    'en': () => import('@/language/en/index.js'),
    'tw': () => import('@/language/tw/index.js'),
    'ja': () => import('@/language/ja/index.js'),
    'ko': () => import('@/language/ko/index.js'),
  }

  const langMap = {
    [LANGCN]: 'zh',
    [LANGEN]: 'en',
    [LANGTW]: 'tw',
    [LANGJA]: 'ja',
    [LANGKO]: 'ko',
  }
  const getCurrentLang = async (key) => (await langMessagesMap[key]()).default

  const getLang = () => {
    const winLocale = getCurrentLocale({
      path: window.location.pathname,
      fallbackLocale: getUrlQuery().locale,
    })
    const lang = winLocale
    localStorage.locale = lang
    return langMap[lang]
  }

  const lang = getLang()
  const englishMessages = await getCurrentLang('en')
  const currentMessages = lang === 'en' ? englishMessages : await getCurrentLang(lang)

  const i18n = createI18n({
    globalInjection: false,
    locale: lang,
    fallbackLocale: 'en',
    messages: {
      en: englishMessages,
      [lang]: currentMessages,
    }
  })

  const splice = (...strs) => {
    const locale = i18n.global.locale
    const jmap = {
      'zh': '',
      'en': ' ',
      'tw': ' ',
      'ja': ' ',
      'ko': ' ',
    }
    const j = jmap[locale]
  }

  const new$t = function (...strs) {
    const locale = i18n.global.locale
    const jmap = {
      'en': ' ',
      'zh': '',
      'tw': '',
      'ja': ' ',
      'ko': ' ',
    }
    const j = jmap[locale]

    let value = strs.reduce((str, item, i) => `${str}${i != 0 ? j : ''}${i18n.global.t(item) ?? item}`, '')
    if (locale == 'en' && strs.length > 1) {
      value = value.slice(0, 1).toUpperCase() + value.slice(1, value.length).toLowerCase()
    }
    return value
  }

  i18n.new$t = new$t
  new$t.splice = splice
  new$t.p = () => {
    const locale = i18n.global.locale
    const jmap = {
      'zh': '',
      'en': '&nbsp;',
      'tw': '',
      'ja': '&nbsp;',
      'ko': '&nbsp;',
    }
    return jmap[locale]
  }

  new$t.curLang = () => {
    const locale = i18n.global.locale
    return i18n.global.messages[locale]
  }

  new$t.replace = i18n.global.t

  new$t.changeLange = async (locale) => {
    const key = langMap[locale] || langMap[LANGEN]
    const m = await getCurrentLang(key)
    i18n.global.setLocaleMessage(key, m)
    i18n.global.locale = key
  }
  return { $t: new$t, i18n }
}
